export const MERGE_CONFIRM_VALUE = "MERGE PROJECT";
